import React from "react";
import styles from "./desktopNavbar.module.css";
import { Box, Card, CardActionArea, CardContent, Divider, Tooltip, Typography } from "@mui/material";
import logoDark from "../../../../assets/logo-dark.png";
// Campaign e-mails embed a copy of this file (backend/marketing/logo.png) -
// replace both when the logo changes.
import logoLight from "../../../../assets/logo-light.png";
import { useTheme } from "../../../../contexts/theme";
import { useMenuData } from "../config";
import { ProfileMenu } from "../profileMenu/profileMenu.component";
import { DarkModeToggle } from "../darkModeToggle/darkModeToggle.component";

export const Navbar = () => {
  const menuData = useMenuData();
  const currentPath = window.location.pathname.split("/")[1];
  const { isDarkMode } = useTheme();

  return (
    <>
      <Box className={styles.desktopMenu}>
        <Box>
          <Box>
            <Box className={styles.logoBox}>
              {/* logo-dark.png is the light-on-transparent variant, drawn
                  for the dark card the sidebar becomes in dark mode. */}
              <img className={styles.logoImg} src={isDarkMode ? logoDark : logoLight} alt="Copigo" />
            </Box>
            <Divider variant="middle" />
          </Box>
          <Box className={styles.menuBox}>
            {menuData.map(({ onClick, text, translatedText, icon }, index) => (
              <Tooltip
              title={<Typography variant="body2">{translatedText}</Typography>}
              placement="right"
              arrow
              key={index}
              >
                <Card className={styles.menuCard} onClick={onClick} raised={currentPath === text.toLowerCase()}>
                <CardActionArea>
                  <CardContent className={styles.menuCardContent}>
                      {icon}
                  </CardContent>
                </CardActionArea>
                </Card>
              </Tooltip>
            ))}
          </Box>
        </Box>
        <Box className={styles.bottomBox}>
          <Box className={styles.darkModeToggleBox}>
            <DarkModeToggle />
          </Box>
          <Box className={styles.profileBox}>
            <ProfileMenu />
          </Box>
        </Box>
      </Box>
    </>
  );
};
